import React, { useState,useEffect } from 'react';
import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import * as RestService from '../../services/eisRest';


const AdditionalInfoTab = (props) => {

    const [t] = useTranslation();            
    const [document, setDocument] = useState();
  
 
    const clearDescription = () => {
      formik.setFieldValue('description','');
    }


   

    


    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
      
      if(document==null || document.id==null){return;}
      document.description=values.description;
      
      RestService.callAnyApi(url,document)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          setDocument(data.responseObject);                       
                          toast.success(t('general.message.saveSucceed'));                                                                      
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const clearForm = () => {
      clearDescription();
    }

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    

        description : document ? document.description : ''
      },
      validationSchema: Yup.object({
      //   firstName: Yup.string()   
     //     .nullable()  
      //    .required(t('general.message.required')),
      
      }),
      onSubmit: (values) => {           
          save('document/saveDocument',values);         
          
      }
      
    });

    useEffect(() => {     

     
      formik.setFieldValue('description','');
      setDocument(props.document);
    }, [props.document],formik)

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
              
              <form onSubmit={formik.handleSubmit}>
              <div className="row">
                    
                    <div className="col-12 col-sm-12 col-lg-12">
                      <div className="form-group">
                                  <label>{t('general.label.description')}</label>
                                  <textarea className="form-control" rows="3"
                                            name="description"
                                            onChange={formik.handleChange}
                                            value={formik.values.description ? formik.values.description : ''}></textarea>
                                </div>
                  </div> 	 				
                   
                  </div> 	 	

                  <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={clearForm}>{t('general.button.clearForm')}</Button>                                                        	            	       			
                  </div>
             </form>

        </div>
    );
};

export default AdditionalInfoTab;